













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/partenaire/edit/EditConfig.vue'
import { getDefaultAloPartenaire, AloPartenaire } from '@/models/alo/AloPartenaire'

@Component({
  name: 'ReadConfig',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    partenaire:{
      type:Object,
      default:getDefaultAloPartenaire
    },  
    priorityEditable:{
      type:Boolean,
      default:true      
    },  
    enableEditable:{
      type:Boolean,
      default:true      
    },
    priorityVisible:{
      type:Boolean,
      default:true      
    },    
    enableVisible:{
      type:Boolean,
      default:true      
    },    
    
  }
})
export default class ReadConfig extends Vue {
  
  private partenaire!:AloPartenaire
  private loading!:boolean  
  private priorityEditable!:boolean
  private enableEditable!:boolean
  private priorityVisible!:boolean
  private enableVisible!:boolean  
  
  get editable() {
    return this.priorityEditable || this.enableEditable
  }

  edit() { 
    (this.$refs.edit as Edit).edit(this.partenaire)
  }

}
